module.exports = __webpack_public_path__ + "4c2139770bced427266108c5c887f8ba.png";